import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import { Dropdown } from 'react-bootstrap';
import { UserValidateFields } from '../validate/userValidation';
import ErrorFilter from '../../helper/errorFilter';
import { requestHandler } from '../../helper';
import { addUser } from '../../controller';
import { toast } from 'react-toastify';
import SingleError from '../../helper/SingleError'
function UserAdd({ getAllUsers }) {

    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false)
        setUserData({ userName: '', email: '', password: '', confirmPassword: '', isPremium: false, plan: null, status: true })
    };
    const handleShow = () => setShow(true);


    const [showPassword, setShowPassword] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState(false);
    const [submitCount, setSubmitCount] = useState(0);

    const [errors, setErrors] = useState({});

    const requireField = [
        "userName",
        "password",
        "confirmPassword",
        "email",
        "phone_no"
    ];

    const togglePasswordVisibility1 = () => {
        setShowPassword(!showPassword);
    };
    const togglePasswordVisibility2 = () => {
        setConfirmPassword(!confirmPassword);
    };

    const [userData, setUserData] = useState({
        userName: '',
        email: '',
        password: '',
        confirmPassword: '',
        isPremium: false,
        plan: null,
        status: true,
        phone_no: null
    })

    const handleChange = async (e) => {
        const { name, value } = e.target;

        if (submitCount > 0) {
            let validationErrors = UserValidateFields({ ...userData, [name]: value });
            validationErrors = ErrorFilter(validationErrors, requireField);
            setErrors(validationErrors);
            if (Object.keys(validationErrors).length === 0) {
                delete errors[name];
            }
        }
        setUserData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        setSubmitCount(prevCount => prevCount + 1);
        const updatedValues = { ...userData };

        let validationErrors = UserValidateFields(updatedValues);
        validationErrors = ErrorFilter(validationErrors, requireField);
        setErrors(validationErrors);
        if (Object.keys(validationErrors).length === 0) {

            delete updatedValues.confirmPassword;
            if (updatedValues.plan === null) {
                delete updatedValues.plan
            }
            await requestHandler(
                async () => await addUser(updatedValues),
                null,
                (res) => {
                    toast.success(res.message);
                    handleClose(); // Optionally close the modal upon success
                    // Clear the form or reset userData if needed
                    setUserData({
                        userName: '',
                        email: '',
                        password: '',
                        confirmPassword: '',
                        isPremium: false,
                        plan: null,
                        status: true,
                        phone_no: null
                    });
                    getAllUsers();
                },
                () => { }
            )

        }

    }

    return (
        <>
            <button className='add-btn' onClick={handleShow}>
                <img src="../images/png/plush.png" width={12} height={12} alt="" />
                <p className='m-0'>Add</p>
            </button>

            <Modal className='modal-main' scrollable show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center">
                            <div className="col-11 col-8">
                                <h2>Add User</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>User Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter User" name='userName' value={userData.userName} onChange={handleChange} />
                                <SingleError error={errors?.userName} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>E-mail</Form.Label>
                                <Form.Control type="text" placeholder="Enter E-mail" name='email' value={userData.email} onChange={handleChange} />
                                <SingleError error={errors?.email} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Phone No</Form.Label>
                                <Form.Control type="number" placeholder="Enter E-mail" name='phone_no' value={userData.phone_no} onChange={handleChange}
                                />
                                <SingleError error={errors?.phone_no} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Premium</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle>
                                        {userData.isPremium ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, isPremium: false })}>Deactive</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, isPremium: true })}>Active</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Plan</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle variant="success">
                                        {userData.plan || 'Select Plan'}

                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, plan: 'MONTHLY' })}>Monthly</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, plan: 'YEARLY' })}>Yearly</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, plan: 'ONE_TIME' })}>One Time</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Status</Form.Label>
                                <Dropdown className='status-btn'>
                                    <Dropdown.Toggle>
                                        {userData.status ? 'Active' : 'Deactive'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, status: true })}>Active</Dropdown.Item>
                                        <Dropdown.Item onClick={() => setUserData({ ...userData, status: false })}>Deactive</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword1">
                                <Form.Label>Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={showPassword ? 'text' : 'password'}
                                        placeholder="Enter Password"
                                        className='input-border-0'
                                        value={userData.password}
                                        onChange={handleChange}
                                        name='password'
                                    />
                                    <img
                                        width={22}
                                        src={showPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility1}
                                    />
                                </div>
                                <SingleError error={errors?.password} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formGroupPassword2">
                                <Form.Label>Confirm Password</Form.Label>
                                <div className='form-control d-flex align-items-center ps-0 py-0'>
                                    <Form.Control
                                        type={confirmPassword ? 'text' : 'password'}
                                        placeholder="Enter Confirm Password"
                                        className='input-border-0'
                                        name='confirmPassword'
                                        value={userData.confirmPassword}
                                        onChange={handleChange}
                                    />
                                    <img
                                        width={22}
                                        src={confirmPassword ? "../images/png/show-eye.png" : "../images/png/close-eye.png"}
                                        alt=""
                                        style={{ cursor: 'pointer' }}
                                        onClick={togglePasswordVisibility2}
                                    />
                                </div>
                                <SingleError error={errors?.confirmPassword} />
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button' onHide={handleClose}>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UserAdd